import React, { useState, useContext, useEffect, useRef } from 'react';
import styles from './styles/MobileNav.module.css';
import NavbarMenu from './NavbarMenu';
import AuthContext from '../../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import NavbarNotifications from './NavbarNotifications';
import NavbarSearch from "./NavbarSearch"
import AuthModal from '../../auth/AuthModal';
import { FaBars, FaBell, FaHome, FaPlus, FaSearch, FaUser, FaUserTie, FaShoppingBag } from 'react-icons/fa';
import CreateScenarioModal from './CreateScenarioModal';
import PermissionsContext from '../../../context/PermissionsContext';
import NotificationContext from '../../../context/NotificationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Upper nav bar on mobile :

const MobileNav = () => {
    const { loggedIn, user, authLoading } = useContext(AuthContext);
    const { scenarioCount } = useContext(PermissionsContext);
    const { hasNewNotification, dismissBadge } = useContext(NotificationContext);

    const [showMenu, setShowMenu] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [authModalState, setAuthModalState] = useState('login');
    const [acceptInvite, setAcceptInvite] = useState(false);
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createAllowed, setCreateAllowed] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    const navigate = useNavigate();
    const location = useLocation();

    const notificationsWrapperRef = useRef(null);
    const menuWrapperRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
        if (location.state) {
            const { showModal, authModalState, acceptInvite } = location.state;
            setShowModal(showModal);
            setAuthModalState(authModalState);
            setAcceptInvite(acceptInvite);
        }
    }, [location.state]);

    useEffect(() => {
        if(user) setCreateAllowed((user.tier === 0 && scenarioCount < 5) || user.tier > 0);
    }, [user, scenarioCount])

    const handleOpenCreateModal = () => {
        setShowCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
    };

    const handleClickNotifications = () => {
        setShowNotifications(!showNotifications);
        setShowMenu(false);
        dismissBadge();
    };

    const handleClickMenu = () => {
        setShowMenu(!showMenu);
        setShowNotifications(false);
    };

    
    useEffect(() => {
        const handleClickOutsideNotifications = (event) => {
            if (notificationsWrapperRef.current && !notificationsWrapperRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsideNotifications);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideNotifications);
        };
    }, []);

    
    useEffect(() => {
        const handleClickOutsideMenu = (event) => {
            if (menuWrapperRef.current && !menuWrapperRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsideMenu);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideMenu);
        };
    }, []);

    const handleClickLogIn = () => {
        setShowModal(!showModal);
        setShowNotifications(false);
        setShowMenu(false);
        setAuthModalState('login');
    }

    const handleClickSignUp = () => {
        setShowModal(!showModal);
        setShowNotifications(false);
        setShowMenu(false);
        setAuthModalState('sign up');
    }

    const toggleSearch = () => {
        setIsSearchExpanded(!isSearchExpanded);
    };

    const handleClickProfile = async () => {
        try {
            if (user) {
                navigate(`/user/${user.username}`, { state: { fromNavbar: true } });
                setShowMenu(false);
            }
        } catch (error) {
            console.error(`Error retrieving user information: ${error}`);
        }
    };


    if (authLoading) {
        return null;
    }

    return isMobile ? (
        <div className={styles.mobileNavbar}>

            {/* Row 1 - Logo, Notifications, Profile */}
            <div className={styles.topRow}>
                <img
                    className={styles.logo}
                    src={require('../../../images/logo_teal_background.png')}
                    alt="Home"
                    onClick={loggedIn === false ? () => navigate('/') : () => navigate('/home')}
                />

                <div className={styles.rightIcons}>
                    <div className={styles.mobileIcon} onClick={handleClickNotifications}>
                        <FaBell />
                        {hasNewNotification && <span className={styles.notifications}>!</span>}
                    </div>

                    <div className={styles.profile} onClick={handleClickProfile}>
                        {user?.profilePicture ? (
                            <img
                                src={user.profilePicture}
                                alt="Profile"
                                className={styles.profileImage}
                            />
                        ) : (
                            <FaUser className={styles.mobileNoProfilePicture} />
                        )}
                    </div>
                </div>
            </div>

            {/* ROW 2 */}
            <div className={styles.search}>
                <NavbarSearch inline fullWidth/>
            </div>

            {/* DROPDOWNS */}
            {showNotifications && (
                <NavbarNotifications setShowNotifications={setShowNotifications} />
            )}

            {showMenu && (
                <NavbarMenu
                    setShowMenu={setShowMenu}
                    user={user}
                />
            )}

        </div>
    ) : null;
    
};

export default MobileNav;